import { ApiResourceBaseClass as o } from "./baseApiCalls.js";
const e = "holidays";
class n extends o {
  /**
   * Finds the holidays for the given countries
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/holidays`
   *
   * @param {HolidaysParams} queryParams - The list of countries for which we want the holidays
   * @returns {Promise<HolidaysResponseBody>} The holidays
   */
  getHolidays = async (s) => {
    const { data: t } = await this.get(e, {
      ...s,
      countries: s.countries.join(",")
    });
    return t;
  };
}
export {
  e as HOLIDAYS_RESOURCE_URI,
  n as Holidays
};
